import { io, Socket } from "socket.io-client";
import { eventChannel } from "redux-saga";
import { SharedCallsData } from "@sms/shared/calls/calls.interface";

import { BASE_URL_WS } from "../utils/api-fetch";

import { createCall, handleConnectSocketCalls, updateCall } from "./calls.actions";

export const createSocketEventsCallsChannel: any = (): any =>
  eventChannel(emit => {
    socketCalls.on("connect", () => emit(handleConnectSocketCalls()));
    socketCalls.on("createCall", (data: SharedCallsData) => emit(createCall(data)));
    socketCalls.on("updateCall", (data: SharedCallsData) => emit(updateCall(data)));
    return (): void => {
      socketCalls.off("connect");
      socketCalls.off("createCall");
      socketCalls.off("updateCall");
    };
  });

export let socketCalls: Socket;
export function connectSocketCalls(): Socket {
  socketCalls = io(`${BASE_URL_WS}/calls`, {
    transports: ["websocket"]
  });

  return socketCalls;
}
